import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "components/CreditCard/CreditCard";
import { SvgInline } from "components/SvgInline/SvgInline";
import { ScreenProps } from "./types";

export const NzSuccess = ({ state: { accountInfo } }: ScreenProps) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <SvgInline name="icon-celebrate" size="120" />
    <Text>
      Your application has been submitted. We will be in touch within the next 3
      working days.
    </Text>
    <Link appearance="primary-button" href="/manage-account" newTab={false}>
      Manage account
    </Link>
  </Stack>
);
